<template>
  <q-dialog :value="show" @hide="onHide" persistent>
    <q-card style="width: 80vw; max-width: 1000px;">
      <q-card-section class="row items-center q-pb-none bg-primary text-white">
        <div class="text-h6">Trip Details (ID: {{ trip ? trip.id : 'N/A' }})</div>
        <q-space />
        <q-btn icon="close" flat round dense @click="onHide" text-color="white"/>
      </q-card-section>

      <q-separator />

      <q-card-section style="max-height: 75vh;" class="scroll q-pa-none">
        <div v-if="trip" class="row no-wrap">
        
          <!-- Left Panel: Details -->
          <div class="col-12 col-md-5 q-pa-md">
            <!-- Removed outer div & gutter -->
              <!-- Basic Trip Info Card -->
              <q-card flat bordered class="q-mb-md"> <!-- Added bottom margin -->
                 <!-- Removed card header -->
                 <q-list padding> <!-- Removed dense -->
                   <q-item>
                    <q-item-section avatar top class="q-item-section-avatar-minwidth">
                        <q-icon name="mdi-identifier" color="grey-7" size="xs" />
                    </q-item-section>
                    <q-item-section>
                      <q-item-label class="text-caption text-weight-bold text-grey-8">Trip ID</q-item-label>
                      <q-item-label class="text-body2">{{ trip.id || 'N/A' }}</q-item-label>
                    </q-item-section>
                  </q-item>
                  <q-item>
                    <q-item-section avatar top class="q-item-section-avatar-minwidth">
                        <q-icon name="mdi-truck-delivery" color="grey-7" size="xs" />
                    </q-item-section>
                    <q-item-section>
                      <q-item-label class="text-caption text-weight-bold text-grey-8">Type</q-item-label>
                      <q-item-label class="text-body2">{{ trip.tripType || 'N/A' }}</q-item-label>
                    </q-item-section>
                  </q-item>
                  <q-item>
                    <q-item-section avatar top class="q-item-section-avatar-minwidth">
                        <q-icon name="mdi-calendar-clock" color="grey-7" size="xs" />
                    </q-item-section>
                    <q-item-section>
                      <q-item-label class="text-caption text-weight-bold text-grey-8">Scheduled</q-item-label>
                      <q-item-label class="text-body2">{{ trip.estimatedJobStartDate || 'No Date' }} - {{ trip.estimatedJobStartTime || 'No Time' }}</q-item-label>
                    </q-item-section>
                  </q-item>
                  <q-item>
                    <q-item-section avatar top class="q-item-section-avatar-minwidth">
                         <q-icon name="mdi-list-status" color="grey-7" size="xs" />
                    </q-item-section>
                    <q-item-section>
                      <q-item-label class="text-caption text-weight-bold text-grey-8">Status</q-item-label>
                      <q-item-label>
                        <q-badge :color="getStatusColor(getTripViewStatus(trip))" text-color="white" class="q-py-xs q-px-sm">
                            {{ getTripViewStatus(trip).toUpperCase() }}
                        </q-badge>
                      </q-item-label>
                    </q-item-section>
                  </q-item>
                  <q-item v-if="trip.tripNotes">
                    <q-item-section avatar top class="q-item-section-avatar-minwidth">
                        <q-icon name="mdi-note-text" color="grey-7" size="xs" />
                    </q-item-section>
                    <q-item-section>
                      <q-item-label class="text-caption text-weight-bold text-grey-8">Notes</q-item-label>
                      <q-item-label class="text-body2" style="white-space: pre-wrap;">{{ trip.tripNotes }}</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-card>

              <!-- Location Info Card -->
              <q-card flat bordered class="q-mb-md"> <!-- Added bottom margin -->
                 <!-- Removed card header -->
                <q-list padding> <!-- Removed dense -->
                  <q-item v-for="(loc, index) in formattedLocations" :key="`loc-${index}`">
                      <q-item-section avatar top class="q-item-section-avatar-minwidth">
                        <q-icon :name="loc.primary ? 'mdi-map-marker-star' : 'mdi-map-marker'" :color="loc.primary ? 'deep-orange' : 'grey-7'" size="sm"/>
                      </q-item-section>
                      <q-item-section>
                        <q-item-label class="text-weight-medium">
                             <!-- Make type bold -->
                            <span class="text-weight-bold">{{ loc.locationType === 'pickup' ? 'Pickup' : 'Dropoff' }}</span> {{ loc.primary ? '(Primary)' : '' }}
                        </q-item-label>
                        <q-item-label caption class="text-weight-medium"> <!-- Make name bold -->
                            {{ loc.name || 'N/A' }}
                        </q-item-label>
                         <q-item-label caption>
                            {{ loc.address || 'No address' }}
                        </q-item-label>
                        <q-item-label caption v-if="loc.coordinate" class="text-italic text-grey-6">{{ loc.coordinate }}</q-item-label>
                      </q-item-section>
                  </q-item>
                </q-list>
              </q-card>

              <!-- Driver Assignment Info Card -->
              <q-card flat bordered v-if="assignment" class="q-mb-md"> <!-- Added bottom margin -->
                 <!-- Removed card header -->
                <q-list padding> <!-- Removed dense -->
                   <q-item>
                    <q-item-section avatar top class="q-item-section-avatar-minwidth">
                        <q-icon name="mdi-account" color="grey-7" size="xs" />
                    </q-item-section>
                    <q-item-section>
                      <q-item-label class="text-caption text-weight-bold text-grey-8">Driver</q-item-label>
                      <q-item-label class="text-body2">{{ assignmentDriverName }}</q-item-label>
                    </q-item-section>
                  </q-item>
                  <q-item>
                    <q-item-section avatar top class="q-item-section-avatar-minwidth">
                        <q-icon name="mdi-list-status" color="grey-7" size="xs" />
                    </q-item-section>
                    <q-item-section>
                      <q-item-label class="text-caption text-weight-bold text-grey-8">Assignment Status</q-item-label>
                      <q-item-label>
                        <q-badge :color="getStatusColor(assignment.status)" text-color="white" class="q-py-xs q-px-sm">
                            {{ assignment.status ? assignment.status.toUpperCase() : 'N/A' }}
                        </q-badge>
                      </q-item-label>
                    </q-item-section>
                  </q-item>
                   <q-item v-if="showUnassignmentReason">
                    <q-item-section avatar top class="q-item-section-avatar-minwidth">
                        <q-icon name="mdi-comment-remove-outline" color="grey-7" size="xs" />
                    </q-item-section>
                    <q-item-section>
                      <q-item-label class="text-caption text-weight-bold text-grey-8">Reason</q-item-label>
                      <q-item-label class="text-body2" style="white-space: pre-wrap;">{{ assignment.unassignmentReason }}</q-item-label>
                    </q-item-section>
                  </q-item>
                   <q-item v-if="assignment.driverLat && assignment.driverLng">
                    <q-item-section avatar top class="q-item-section-avatar-minwidth">
                        <q-icon name="mdi-map-marker-radius" color="grey-7" size="xs" />
                    </q-item-section>
                    <q-item-section>
                      <q-item-label class="text-caption text-weight-bold text-grey-8">Current Location</q-item-label>
                      <q-item-label class="text-body2">Lat: {{ assignment.driverLat }}, Lng: {{ assignment.driverLng }}</q-item-label>
                    </q-item-section>
                  </q-item>
                   <q-item v-if="parsedLocationHistory.length > 0">
                    <q-item-section avatar top class="q-item-section-avatar-minwidth">
                        <q-icon name="mdi-map-marker-path" color="grey-7" size="xs" />
                    </q-item-section>
                    <q-item-section>
                      <q-item-label class="text-caption text-weight-bold text-grey-8">Location History</q-item-label>
                      <q-item-label class="text-body2">{{ parsedLocationHistory.length }} points recorded</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-card>

              <!-- Proof of Delivery Card -->
              <q-card flat bordered v-if="signatureImage || podImages.length > 0" class="q-mb-md">
                <q-list padding>
                  <q-item-label header class="text-weight-bold q-pl-md q-pt-sm">Proof of Delivery</q-item-label>
                  
                  <!-- Signature -->
                  <q-item v-if="signatureImage">
                    <q-item-section avatar top class="q-item-section-avatar-minwidth">
                        <q-icon name="mdi-draw" color="grey-7" size="xs" />
                    </q-item-section>
                    <q-item-section>
                      <q-item-label class="text-caption text-weight-bold text-grey-8">Signature</q-item-label>
                      <q-item-label>
                        <img :src="signatureImage" alt="Signature" style="max-width: 200px; max-height: 100px; border: 1px solid #eee; margin-top: 4px;" />
                      </q-item-label>
                    </q-item-section>
                  </q-item>
                  
                  <!-- POD Images -->
                  <q-item v-if="podImages.length > 0">
                    <q-item-section avatar top class="q-item-section-avatar-minwidth">
                        <q-icon name="mdi-camera" color="grey-7" size="xs" />
                    </q-item-section>
                    <q-item-section>
                      <q-item-label class="text-caption text-weight-bold text-grey-8">Images ({{ podImages.length }})</q-item-label>
                      <q-item-label class="q-gutter-sm q-mt-xs">
                        <img v-for="(imgSrc, index) in podImages" 
                             :key="'pod-' + index" 
                             :src="imgSrc" 
                             alt="Proof of Delivery Image" 
                             style="max-width: 100px; max-height: 100px; border: 1px solid #eee; object-fit: cover; cursor: pointer;" 
                             @click="() => showImageDialog(imgSrc)" 
                        />
                      </q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-card>
          </div>
          
          <!-- Right Panel: Map -->
          <div class="col-12 col-md-7 q-pa-md">
            <div class="text-subtitle1 q-mb-sm">Map Visualization</div>
            <GmapMap
              ref="mapRef" 
              :center="mapCenter"
              :zoom="mapZoom"
              :options="mapOptions"
              style="width: 100%; height: 65vh;"
            >
              <!-- Location Markers -->
              <GmapMarker
                v-for="marker in locationMarkers"
                :key="marker.key"
                :position="marker.position"
                :title="marker.title"
                :label="marker.label"
                :icon="marker.icon"
                :clickable="true"
                @click="mapCenter=marker.position" 
              />

              <!-- Driver Marker -->
              <GmapMarker
                v-if="driverMarker"
                :key="driverMarker.key"
                :position="driverMarker.position"
                :title="driverMarker.title"
                :icon="driverMarker.icon"
                :clickable="true"
                @click="mapCenter=driverMarker.position"
              />

              <!-- Driver Path -->
              <GmapPolyline
                v-if="driverPath.length > 0"
                :path="driverPath"
                :options="{ strokeColor: '#FF0000', strokeWeight: 2, strokeOpacity: 0.8 }"
              />
            </GmapMap>
          </div>

        </div>
        <div v-else class="text-center q-pa-xl text-grey">
          <q-icon name="mdi-information-outline" size="lg"/><br/>
          No trip data available to display.
        </div>
      </q-card-section>

       <!-- Image Viewer Dialog (Optional but recommended) -->
      <q-dialog v-model="imageDialogVisible">
        <q-card>
          <q-img :src="currentImageSrc" style="max-width: 80vw; max-height: 80vh;" fit="contain"/>
           <q-card-actions align="right">
                <q-btn flat label="Close" color="primary" v-close-popup />
           </q-card-actions>
        </q-card>
      </q-dialog>

    </q-card>
  </q-dialog>
</template>

<script>
import { computed, ref, watch, nextTick } from 'vue';
import { QDialog, QCard, QCardSection, QSeparator, QBtn, QIcon, QSpace, QList, QItem, QItemSection, QItemLabel, QBadge, QCardActions, QImg } from 'quasar';
import { GmapMap, GmapMarker, GmapPolyline } from 'vue2-google-maps';

// Helper function to parse coordinates
function parseCoords(coordString) {
  if (!coordString || typeof coordString !== 'string') return null;
  const parts = coordString.split(',').map(s => parseFloat(s.trim()));
  if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
    return { lat: parts[0], lng: parts[1] };
  }
  return null;
}

export default {
  name: 'ViewTripDetails',
  components: { 
    QDialog, QCard, QCardSection, QSeparator, QBtn, QIcon, QSpace, QList, QItem, QItemSection, QItemLabel, QBadge, QCardActions, QImg,
    // Rely on global registration for these now
    // GmapMap, GmapMarker, GmapPolyline 
  },
  props: {
    tripData: { type: Object, default: null },
    show: { type: Boolean, default: false }
  },
  // Use SETUP mainly for reactive data and computed props
  setup(props, { emit }) {
    const trip = ref(null);
    const mapRef = ref(null);
    const mapCenter = ref({ lat: 3.1390, lng: 101.6869 });
    const mapZoom = ref(10);
    const mapOptions = ref({
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false
    });
    const directionsService = ref(null);
    const directionsRenderer = ref(null);
    const mapInstance = ref(null);
    const imageDialogVisible = ref(false); // For image viewer
    const currentImageSrc = ref(''); // For image viewer

    watch(() => props.tripData, (newData) => {
      trip.value = newData;
      // Trigger map updates after data changes
      nextTick(() => {
          initializeMapServices(); // Ensure services are ready
          fitMapToBounds(); 
      });
    }, { immediate: true, deep: true });

    // --- Computed Properties --- 
    const assignment = computed(() => {
      return (trip.value && trip.value.trip_driver_assignments && trip.value.trip_driver_assignments.length > 0)
        ? trip.value.trip_driver_assignments[0]
        : null;
    });

    // NEW: Computed property to check if reason should be shown
    const showUnassignmentReason = computed(() => {
      if (!assignment.value || !assignment.value.status || !assignment.value.unassignmentReason) {
        return false;
      }
      const lowerStatus = assignment.value.status.toLowerCase();
      return (lowerStatus === 'rejected' || lowerStatus === 'cancelled') && assignment.value.unassignmentReason;
    });

    const assignmentDriverName = computed(() => {
        if (assignment.value && assignment.value.Driver && assignment.value.Driver.name) return assignment.value.Driver.name;
        if (assignment.value && assignment.value.driverId) return `Driver ID: ${assignment.value.driverId}`;
        return 'N/A';
    });
    const parsedLocationHistory = computed(() => {
        if (!assignment.value || !assignment.value.locationHistory) return [];
        try {
            const history = typeof assignment.value.locationHistory === 'string'
                ? JSON.parse(assignment.value.locationHistory)
                : assignment.value.locationHistory;
            
            const historyData = (Array.isArray(history) ? history : []);
            console.log("ViewTripDetails: Parsed History Array (before map/filter):", historyData); // Log the array before mapping
            
            const mappedCoords = historyData
                        .map(p => ({ lat: parseFloat(p.driverLat), lng: parseFloat(p.driverLng) })) // Ensure numbers
                        .filter(p => p.lat != null && !isNaN(p.lat) && p.lng != null && !isNaN(p.lng)); // Stricter filter
            console.log("ViewTripDetails: Mapped & Filtered Coords for Polyline:", mappedCoords); // Log the final coords
            return mappedCoords; 
        } catch (e) {
            console.error("Error processing location history:", e);
            return [];
        }
    });
    const locationMarkers = computed(() => {
        if (!trip.value || !trip.value.locations) return [];
        return trip.value.locations.map((loc, index) => {
            const coords = parseCoords(loc.meta && loc.meta.coordinate);
            if (!coords) return null;
            const isPrimary = loc.primary;
            const type = loc.locationType || (trip.value.tripType === 'pickup' ? (isPrimary ? 'pickup' : 'dropoff') : 'dropoff');
            
            // --- Marker Icon Logic ---
            let iconUrl = 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'; // Default red (Dropoff)
            if (type === 'pickup') {
                iconUrl = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'; // Green for pickup
            }
            if (isPrimary) {
                iconUrl = 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'; // Blue for primary
            }
            // --------------------------

            return {
                key: `loc-${loc.poiId || index}`,
                position: coords,
                title: (loc.meta && loc.meta.name) || `POI ${loc.poiId}`,
                icon: {
                   url: iconUrl,
                   scaledSize: { width: 35, height: 35 }, // Slightly larger
                   labelOrigin: { x: 18, y: -10 } // Adjust label origin slightly
                }
            };
        }).filter(m => m !== null);
    });
    const driverMarker = computed(() => {
        if (!assignment.value || !assignment.value.driverLat || !assignment.value.driverLng) return null;
        
        // --- Driver Icon --- (Using a simple colored dot for now)
        const driverIcon = {
            url: 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png', // Yellow for driver
            scaledSize: { width: 35, height: 35 },
        };
        // ------------------

        return {
            key: 'driver',
            position: { lat: parseFloat(assignment.value.driverLat), lng: parseFloat(assignment.value.driverLng) },
            title: `Driver: ${assignmentDriverName.value} (Current)`,
            icon: driverIcon
        };
    });
    const driverPath = computed(() => parsedLocationHistory.value);
    const finalDestinationMarker = computed(() => {
      if (!locationMarkers.value || locationMarkers.value.length === 0) return null;
      // Assuming locationMarkers is already sorted by sequence implicitly or explicitly if needed
      return locationMarkers.value[locationMarkers.value.length - 1];
    });
    const formattedLocations = computed(() => {
        if (!trip.value || !trip.value.locations) return [];
        return trip.value.locations.map(loc => ({
            ...loc,
            name: (loc.meta && loc.meta.name) || `POI ID: ${loc.poiId}`,
            address: (loc.meta && loc.meta.address),
            coordinate: (loc.meta && loc.meta.coordinate),
            locationType: loc.locationType || (trip.value.tripType === 'pickup' ? (loc.primary ? 'pickup' : 'dropoff') : 'dropoff')
        })).sort((a, b) => (a.sequence || 0) - (b.sequence || 0));
    });

    // --- NEW: Computed properties for POD ---
    const signatureImage = computed(() => {
      if (assignment.value && assignment.value.signature && Array.isArray(assignment.value.signature) && assignment.value.signature.length > 0 && assignment.value.signature[0].base64image) {
        // Ensure the base64 string has the correct prefix
        const rawBase64 = assignment.value.signature[0].base64image;
        return rawBase64.startsWith('data:image') ? rawBase64 : `data:image/png;base64,${rawBase64}`;
      }
      return null;
    });

    const podImages = computed(() => {
      if (assignment.value && assignment.value.proofOfDelivery && Array.isArray(assignment.value.proofOfDelivery)) {
        return assignment.value.proofOfDelivery
          .map(item => item.base64image)
          .filter(img => img) // Filter out empty/null images
          .map(img => img.startsWith('data:image') ? img : `data:image/jpeg;base64,${img}`); // Ensure prefix
      }
      return [];
    });
    // --- End NEW ---

    // --- Map Logic --- 
    const initializeMapServices = async () => {
      if (!mapRef.value || !mapRef.value.$mapPromise) return;
      try {
        mapInstance.value = await mapRef.value.$mapPromise;
        directionsService.value = new google.maps.DirectionsService();
        directionsRenderer.value = new google.maps.DirectionsRenderer({
          map: mapInstance.value,
          suppressMarkers: true, // We use our own markers
          preserveViewport: true, // Don't zoom to the directions route automatically
          polylineOptions: {
            strokeColor: '#1976D2', // Example: Blue color for directions
            strokeOpacity: 0.7,
            strokeWeight: 5
          }
        });
        console.log("ViewTripDetails: Directions services initialized.");
        // Initial attempt to draw directions if data is already present
        await fetchAndDrawDirections(); 
      } catch (error) {
        console.error("Error initializing map services:", error);
      }
    };
    const fetchAndDrawDirections = async () => {
      if (!directionsService.value || !directionsRenderer.value || !driverMarker.value || !finalDestinationMarker.value) {
        console.log("ViewTripDetails: Skipping directions fetch - services or points not ready.");
        // Clear previous directions if points become invalid
        if(directionsRenderer.value) directionsRenderer.value.setDirections({ routes: [] }); 
        return;
      }

      const origin = driverMarker.value.position;
      const destination = finalDestinationMarker.value.position;

      if (!origin || !destination) {
        console.log("ViewTripDetails: Skipping directions fetch - origin or destination invalid.");
         if(directionsRenderer.value) directionsRenderer.value.setDirections({ routes: [] });
        return;
      }

      directionsService.value.route(
        {
          origin: origin,
          destination: destination,
          travelMode: google.maps.TravelMode.DRIVING
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            console.log("ViewTripDetails: Directions fetched successfully.", result);
            directionsRenderer.value.setDirections(result);
          } else {
            console.error(`Directions request failed due to ${status}`);
            // Clear directions on failure
            directionsRenderer.value.setDirections({ routes: [] }); 
          }
        }
      );
    };
    const fitMapToBounds = async () => {
      if (!mapRef.value || !mapRef.value.$mapPromise) return;
      
      try {
         // Wait for the map promise to resolve
         const map = await mapRef.value.$mapPromise;
         // NOW it's safe to use google.maps objects
         const bounds = new google.maps.LatLngBounds(); 
         let pointsAdded = 0;

         locationMarkers.value.forEach(marker => {
            if (marker && marker.position) {
               bounds.extend(marker.position);
               pointsAdded++;
            }
         });

         if (driverMarker.value && driverMarker.value.position) {
            bounds.extend(driverMarker.value.position);
            pointsAdded++;
         }

         if (driverPath.value.length > 0 && pointsAdded <= 1) {
            driverPath.value.forEach(point => {
               bounds.extend(point);
               pointsAdded++;
            });
         } 

         if (pointsAdded > 1) { 
            map.fitBounds(bounds);
         } else if (pointsAdded === 1) {
             let singlePoint = null;
             if (locationMarkers.value.length > 0 && locationMarkers.value[0].position) {
                 singlePoint = locationMarkers.value[0].position;
             } else if (driverMarker.value && driverMarker.value.position) {
                 singlePoint = driverMarker.value.position;
             } else if (driverPath.value.length > 0) {
                 singlePoint = driverPath.value[0];
             }
             if(singlePoint) {
                 map.setCenter(singlePoint);
                 map.setZoom(14);
             }
         }

      } catch (error) {
         console.error("Error fitting map bounds:", error);
      }
    };

    // --- Watcher for Directions ---
    watch([driverMarker, finalDestinationMarker, () => props.show], async ([newDriver, newDest, newShow]) => {
       if (newShow && newDriver && newDest && mapInstance.value && directionsService.value && directionsRenderer.value) {
           await fetchAndDrawDirections();
       } else if (!newShow && directionsRenderer.value) {
           directionsRenderer.value.setDirections({ routes: [] }); 
       }
    });

    // --- NEW: Method for Image Viewer ---
    const showImageDialog = (src) => {
        currentImageSrc.value = src;
        imageDialogVisible.value = true;
    };
    // --- End NEW ---

    // Return ONLY reactive refs and computed properties needed by methods/template
    return {
      trip,
      mapRef,
      mapCenter,
      mapZoom,
      mapOptions,
      assignment,
      showUnassignmentReason,
      assignmentDriverName,
      parsedLocationHistory,
      formattedLocations,
      locationMarkers,
      driverMarker,
      driverPath,
      signatureImage,
      podImages,
      imageDialogVisible,
      currentImageSrc,
      showImageDialog
    };
  },
  // Use METHODS for template event handlers and helpers
  methods: {
    onHide() {
      this.$emit('update:show', false); // Use this.$emit
    },
    // Helper methods previously in setup, now access data via `this`
    getTripViewStatus(tripData) { 
      if (!tripData) return 'unknown';
      const tripStatus = tripData.status ? tripData.status.toLowerCase() : null;
      if (['completed', 'cancelled'].includes(tripStatus)) return tripStatus;

      const assign = (tripData.trip_driver_assignments && tripData.trip_driver_assignments.length > 0) ? tripData.trip_driver_assignments[0] : null;
      if (assign) {
        const assignmentStatus = assign.status ? assign.status.toLowerCase() : null;
        if (assignmentStatus && assignmentStatus !== 'assigned') return assignmentStatus;
        if (assign.driverLat && assign.driverLng) return 'in-progress';
        if (assign.driverId) return 'assigned';
      }
      return tripStatus || 'unassigned';
    },
    getStatusColor(status) {
        if (!status) return 'grey';
        const lowerStatus = status.toLowerCase();
        switch(lowerStatus) {
            case 'in-progress': case 'in-transit': case 'delivered': return 'blue';
            case 'completed': return 'green';
            case 'cancelled': return 'red';
            case 'assigned': return 'teal';
            case 'unassigned': return 'orange';
            default: return 'grey';
        }
    },
     // Method to trigger map centering (example if needed from template)
     centerOnMarker(marker) {
         if (marker && marker.position) {
             this.mapCenter = marker.position; // Access mapCenter ref via this
             this.mapZoom = 15; // Example zoom
         }
     }
  }
}
</script>

<style scoped>
.q-item__section--avatar {
    min-width: 30px; /* Adjust icon alignment */
}

.q-item-section-avatar-minwidth {
    min-width: 30px !important;
}
</style>
